import React, { forwardRef } from 'react';
import { Box, BoxProps } from '@mui/material';
import { TextareaAutosizeProps } from '@mui/material/TextareaAutosize';
import ScrollFadeTextarea from './ScrollFadeTextarea';

export const STORY_COMPOSER_BUTTON_SIZE = 36;
export const storyComposerColumnSx = { width: '100%', maxWidth: 900, mx: 'auto', minWidth: 0 };

/** Shared geometry; each creation flow supplies its own controls and behavior. */
export default function StoryComposer({ sx, ...props }: BoxProps) {
  return <Box {...props} sx={[{
    minWidth: 0, width: '100%', boxSizing: 'border-box',
    bgcolor: '#1b1e28', border: '1px solid rgba(255,255,255,0.12)',
    borderRadius: '18px', p: '15px 13px 9px 17px', boxShadow: '0 5px 20px #00000012',
    '@media (max-width: 1199px)': { borderRadius: '16px' },
  }, ...(Array.isArray(sx) ? sx : [sx])]} />;
}

export const StoryComposerInput = forwardRef<HTMLTextAreaElement, TextareaAutosizeProps>((props, ref) => (
  <Box component={ScrollFadeTextarea} ref={ref} minRows={2} maxRows={10} {...props} sx={{ '&&': {
    display: 'block', width: '100%', border: 0, resize: 'none', bgcolor: 'transparent',
    p: 0, outline: 'none', color: '#fff', font: 'inherit', fontSize: 16, lineHeight: 1.7, caretColor: '#fff',
    overflow: 'auto !important',
    '&::placeholder': { color: '#9398a7', opacity: 1 },
    '&:focus-visible': { outline: 'none', boxShadow: 'none' },
    '@media (max-width: 1199px)': { lineHeight: 1.5 },
  } }} />
));
StoryComposerInput.displayName = 'StoryComposerInput';

export function StoryComposerToolbar({ sx, ...props }: BoxProps) {
  return <Box {...props} sx={[{
    '--studio-composer-button-size': `${STORY_COMPOSER_BUTTON_SIZE}px`,
    display: 'grid', gridTemplateColumns: `${STORY_COMPOSER_BUTTON_SIZE}px minmax(0, 1fr) auto`,
    alignItems: 'center', gap: '10px', mt: '7px',
  }, ...(Array.isArray(sx) ? sx : [sx])]} />;
}
